import styled, { ThemeProps } from 'styled-components';
import { GlobalTheme, globalTheme, ThemeWithOverrides } from '@cld/component-theme';

export type SeparatorMargin = keyof GlobalTheme['spacing'];

export interface SeparatorProps {
  horizontalMargin?: SeparatorMargin;
  verticalMargin?: SeparatorMargin;
}

/**
 * Returns the actual value of the provided spacing constant from theme or 0 if not provided.
 * @param {string} propName name of the prop with spacing value to resolve
 */
const resolveSpacing = (propName: keyof SeparatorProps) => (props: SeparatorProps & ThemeProps<ThemeWithOverrides>) => {
  const spacing = props[propName];
  return spacing ? globalTheme.spacing[spacing](props) : 0;
};
const resolveHorizontalMargin = (props: SeparatorProps & ThemeProps<ThemeWithOverrides>) => resolveSpacing('horizontalMargin')(props);
const resolveVerticalMargin = (props: SeparatorProps & ThemeProps<ThemeWithOverrides>) => resolveSpacing('verticalMargin')(props);

export const HorizontalSeparator = styled.div<SeparatorProps>`
  height: 1px;
  width: calc(100% - 2 * ${resolveHorizontalMargin});
  margin: ${resolveVerticalMargin} ${resolveHorizontalMargin};
  background-color: ${globalTheme.palette.secondary};
`;

export const VerticalSeparator = styled.div<SeparatorProps>`
  width: 1px;
  height: calc(100% - 2 * ${resolveVerticalMargin});
  margin: ${resolveVerticalMargin} ${resolveHorizontalMargin};
  background-color: ${globalTheme.palette.secondary};
`;
